import { Component , Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-app-button',
  templateUrl: './app-button.component.html',
  styleUrls: ['./app-button.component.css']
})
export class AppButtonComponent implements OnInit{
  @Input() buttonText: string = '';
  @Input() disabled: boolean = false;
  @Input() link:string ='';
 ngOnInit() {
  console.log(this.buttonText);
  console.log(this.link);
 }
}
